export const CART_NAME = 'jo_order-id'
export const TOKEN_NAME = 'jo_token'

export const CART_INCLUDES = ['line_items'] as const

export const ORDER_ATTRS = [
  'status',
  'number',
  'skus_count',
  'formatted_subtotal_amount',
  'formatted_discount_amount',
  'formatted_shipping_amount',
  'formatted_total_tax_amount',
  'formatted_gift_card_amount',
  'formatted_total_amount_with_taxes',
  'checkout_url',
  'line_items',
  'token',
  'subtotal_amount_cents',
  'subtotal_amount_float',
  'total_amount_with_taxes_float',
  'currency_code',
] as const

export const LINE_ITEM_ATTRS = [
  'item_type',
  'image_url',
  'name',
  'sku_code',
  'quantity',
  'metadata',
  'formatted_unit_amount',
  'unit_amount_float',
  'compare_at_amount_float',
  'formatted_compare_at_amount',
  'formatted_total_amount',
  'total_amount_float',
] as const

export const ORDER_SUMMARY_ATTRS = [
  'id',
  'number',
  'status',
  'formatted_subtotal_amount',
  'formatted_shipping_amount',
  'formatted_discount_amount',
  'formatted_gift_card_amount',
  'formatted_total_tax_amount',
  'formatted_total_amount_with_taxes',
  'skus_count',
  'checkout_url',
  'line_items.item_type',
  'line_items.id',
  'line_items.sku_code',
  'line_items.quantity',
  'line_items.formatted_total_amount',
  'line_items.compare_at_amount_float',
  'line_items.formatted_compare_at_amount',
  'line_items.formatted_unit_amount',
  'line_items.formatted_total_amount',
  'line_items.total_amount_float',
  'line_items.unit_amount_float',
  'line_items.name',
  'line_items.image_url',
  'line_items.metadata',
  'token',
  'subtotal_amount_cents',
  'total_amount_with_taxes_float',
  'currency_code',
] as const

export const SKU_INCLUDES = ['prices', 'stock_items'] as const

export const SKU_ATTRS = [
  'id',
  'code',
  'name',
  'inventory',
  'stock_items.quantity',
  'stock_items.id',
  'pieces_per_pack',
  'weight',
  'unit_of_weight',
  'do_not_ship',
  'do_not_track',
  'metadata',
  'prices.currency_code',
  'prices.amount_cents',
  'prices.amount_float',
  'prices.formatted_amount',
  'prices.compare_at_amount_cents',
  'prices.compare_at_amount_float',
  'prices.formatted_compare_at_amount',
] as const
